import React from 'react';
import { MainHeader } from '../../../../components/main-header';
import { Page } from '../../../../components/page';
import { GroupTabs } from '../../components/group/tabs';
import { DialogsLavva } from '../dialogs/dialogs';
import { GroupsBody } from './components';
import { useGroups } from './hooks/use-groups';
import { useUserGroups } from './hooks/use-user-groups';

const Groups: React.FC = () => {
  const { activeGroup, activeTabIndex, isCarouselContent, groupTabsVisible, handleSetActiveGroupIndex } =
    useUserGroups();
  const { popUpNavLinks } = useGroups(activeGroup);

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height"
      carouselContent={isCarouselContent}
      header={
        <>
          <MainHeader navLinks={popUpNavLinks} />
          {groupTabsVisible && (
            <GroupTabs activeTabIndex={activeTabIndex} setActiveTabIndex={handleSetActiveGroupIndex} />
          )}
        </>
      }
    >
      <GroupsBody activeTabIndex={activeTabIndex} setActiveTabIndex={handleSetActiveGroupIndex} />
      <DialogsLavva />
    </Page>
  );
};

export default Groups;
